const state = {
  firstDayOfWeek: 1,
  workspaceId: 186448,
  timeEntryQueries: [],
  taskQueries: [],
  userSelectorIsCollapsed: false,
  summaryProp: 'client',
  appIsLoading: false
}

const mutations = {
  saveTimeEntryQuery (state, queryString) {
    state.timeEntryQueries.push({value: JSON.parse(JSON.stringify(queryString)), date: new Date()})
  },
  removeTimeEntryQuery (state, queryString) {
    for (var i = state.timeEntryQueries.length - 1; i >= 0; --i) {
      if (JSON.stringify(state.timeEntryQueries[i].value) === JSON.stringify(queryString)) {
        state.timeEntryQueries.splice(i, 1)
      }
    }
  },
  clearTimeEntryQueries (state) {
    state.timeEntryQueries = []
  },
  saveTaskQuery (state, queryString) {
    state.taskQueries.push({value: queryString, date: new Date()})
  },
  removeTaskQuery (state, queryString) {
    for (var i = state.taskQueries.length - 1; i >= 0; --i) {
      if (state.taskQueries[i].value === queryString) {
        state.taskQueries.splice(i, 1)
      }
    }
  },
  setUserSelectorIsCollapsed (state, collapsed) {
    state.userSelectorIsCollapsed = collapsed
  },
  setSummaryProp (state, prop) {
    state.summaryProp = prop
  },
  setAppIsLoading (state, status) {
    state.appIsLoading = status
  }
}

const getters = {
  firstDayOfWeek: state => state.firstDayOfWeek,
  workspaceId: state => state.workspaceId,
  timeEntryQueries: state => { return state.timeEntryQueries },
  taskQueries: state => state.taskQueries,
  userSelectorIsCollapsed: state => state.userSelectorIsCollapsed,
  summaryProp: state => state.summaryProp,
  appIsLoading: state => state.appIsLoading
}

export default {
  state,
  mutations,
  getters
}
